import * as React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';
/* import { debug } from '../../../utils';
 * const log = debug('lego:EditReview.tsx');*/
import Stars from '../../components/fields/Stars';

import classNames from 'classnames';
const styles = require('./EditReview.less') as any;


const MAX_COMMENT_CHARS = 1000;
interface EditReviewProps {
	zIndex: any;
		aspect: any;
		idx: number;
		review: any;
		selected: boolean;
		toggleAspect: any;
		my_review?: any;
	style: any;
	browser?: any;
	error: any;
}
import { Motion, spring } from 'react-motion'
const MIN_HEIGHT = 8
interface EditReviewState { }
const selector = formValueSelector('reviewForm');
const mapStateToProps = (state, ownProps) => ({
	my_review: selector(state, ownProps.aspect.id) || {comment: '', rating: 0},
	browser: state.browser,
});
@connect(mapStateToProps)
// @reduxForm({form: 'reviewForm', enableReinitialize: true, keepDirtyOnReinitialize: true})
export default class EditReview extends React.Component<EditReviewProps,EditReviewState> {
		render() {
			const {aspect, selected, toggleAspect, my_review, style, browser, error} = this.props;
			return (
h(Motion, { style: { selected: selected ? spring(MIN_HEIGHT) : spring(0) } }, [
  s =>
    selected && div(
      C([styles.AspectReview, selected && styles.selected]),
      { onClick: !selected && toggleAspect, style: style },
      [
        header(C(styles.Header), [
          label({ onClick: selected && toggleAspect }, [
            browser.greaterThan.small && 'Edit your ', aspect.name, ' review:',
          ]),
          span({ style: { float: 'right' } }, [
            h(Field, { name: `rating`, component: Stars, stars: { editing: selected } }),
          ]),
        ]),
        s.selected > 0 &&
          div(
            {
              style: {
                overflow: 'hidden',
                width: '100%',
                maxHeight: s.selected == MIN_HEIGHT ? 'none' : s.selected + 'em',
              },
            },
            [
              h(Field, {
                name: `comment`,
                placeholder: 'Write your comment here and select a star rating above...',
                component: 'textarea',
                label: `Aspect ${aspect.name} comment`,
								maxLength: MAX_COMMENT_CHARS,
              }),
              !!error && span(C(styles.MustLeaveComment), [error]),
							my_review.comment.length > 0 && CharacterCount({my_review}),
            ],
          ),
      ],
    ),
])


			)
		}
	/* <Stars name={`${aspect.id}.rating`} value={review.rating} editing={selected} /> */
	/* const mapStateToProps = (state, ownProps) => ({
	 *		 place: state.places[ownProps.routeParams.id],
	 *		 selected_aspect: defaultTo(parseInt(ownProps.location.query.aspect), 0)
	 * });
	 * @connect(mapStateToProps, {getPlace})
	 * @reduxForm({form: 'reviewForm'})*/
}
const C = classes => {
	if (classes) {
		if (classes.map) {
			return classes.map(cls => C(cls)).join('')
		}
		return '.' + classes.split(' ').join('.')
	}
	return ''
}

import { p, header, h2, address, h, li, div, span, label, hr } from 'react-hyperscript-helpers'
/*
 * const render_AspectReview = ({aspect, idx, review}) => (
 *		 <div className={styles.AspectReview}>
 *				 <label>Edit your comment:</label>
 *				 <span style={{float: 'right'}}>stars</span>
 *				 <Field name={`${aspect.name}_comment`} type='search' component='textarea' label={`Aspect ${aspect.name} comment`} />
 *				 <span style={{float: 'right'}}>9/100</span>
 *		 </div>
 * );
 * */
/* const aspectIs = (id) => (review) => review.element == id;
 * const hasComment = (review) => review.comment && review.comment.length > 0;
 * */
//export default withRouter(EditReview);

const CharacterCount = ({my_review}) =>
  span(C(styles.CommentLength), { style: { float: 'right' } }, [
    my_review.comment.length,
    '/',
    MAX_COMMENT_CHARS,
    ' characters',
  ])



// WEBPACK FOOTER //
// ./src/app/containers/Place/EditReview.ts